import _ from "lodash";

import { defaultFilters, emptyFilters } from "./state";

export const SET_ACCOUNTS_DATA = "SET_ACCOUNTS_DATA";
export const SET_PACKAGE_DICTIONARY = "SET_PACKAGE_DICTIONARY";
export const MUTATE_SELECTED_PAGE = "MUTATE_SELECTED_PAGE";
export const MUTATE_FILTERS = "MUTATE_FILTERS";
export const MUTATE_DEFAULT_FILTERS = "MUTATE_DEFAULT_FILTERS";
export const MUTATE_EMPTY_FILTERS = "MUTATE_EMPTY_FILTERS";

export default {
  [SET_ACCOUNTS_DATA]: (state, accountsData) => {
    state.accounts = accountsData.data;
    state.count = accountsData.count;
  },
  [SET_PACKAGE_DICTIONARY]: (state, data) => {
    state.packageDictionary = data.data;
  },
  [MUTATE_SELECTED_PAGE]: (state, page) => {
    state.pagination.page = page;
  },
  [MUTATE_FILTERS]: (state, filters) => {
    if (!_.isEqual(_.merge({}, state.filters), filters)) {
      state.filters = filters;
    }
  },
  [MUTATE_DEFAULT_FILTERS]: (state) => {
    state.filters = _.merge({}, defaultFilters);
  },
  [MUTATE_EMPTY_FILTERS]: (state) => {
    state.filters = _.merge({}, emptyFilters);
  },
};
